import { useState, useCallback } from 'react';
import axiosInstance from '../axios/axios-interceptor';

const useRequest = () => {
  const [reqObj, setReqObj] = useState({
    isLoading: false,
    error: null,
    data: null,
    errorMessage: "",
  });

  const setRequestError = useCallback((error) => {
    setReqObj({ isLoading: false, error, data: null });
  }, []);

  const makeRequest = useCallback(async ({ method = 'POST', url, data = {}, customHeaders = {} }) => {
    setReqObj({ isLoading: true, error: null, data: null });

    try {
      let response;

      switch (method.toUpperCase()) {
        case 'POST':
          response = await axiosInstance.post(url, data, { headers: { ...customHeaders } });
          break;

        case 'PUT':
          response = await axiosInstance.put(url, data, { headers: { ...customHeaders } });
          break;

        case 'DELETE':
          response = await axiosInstance.delete(url, { headers: { ...customHeaders } });
          break;

        case 'PATCH':
          response = await axiosInstance.patch(url, data, { headers: { ...customHeaders } });
          break;

        default:
          throw new Error("Something went wrong");
      }
      if (response.data && response.data.status === "error") {
        const errorMessage = response.data.data;
        setReqObj({ isLoading: false, error: errorMessage, data: null });
        throw new Error(errorMessage);
      }
      
      // console.log(response.data.message, "response")
      setReqObj({ isLoading: false, error: null, data: response.data });
      return response;

    } catch (error) {
      console.error(`${method} error ----- `, error);
      let errorMessage = "";

      if (error?.response) {
        errorMessage = error?.response?.data?.message || "Oops!! Something went wrong";
      } else if (error.message) {
        errorMessage = error.message;
      }

      setReqObj({ isLoading: false, error, errorMessage, data: null });
    }
  }, []);

  return { makeRequest, setRequestError, ...reqObj };
};

export default useRequest;
